import type { Maybe } from '@nova/core';

import { toPresenterPlaceholder } from '@satellite/composables/presenterPlaceholder';

import type { PresenterPlaceholderData } from '@satellite/composables/presenterPlaceholder';
import type { YardAreaDetails } from '@satellite/composables/useYardAreaPresenter';
import type { YardAssetDetails } from '@satellite/composables/useYardAssetPresenter';
import type { YardSpotDetails } from '@satellite/composables/useYardSpotPresenter';

/**
 * Maps check-task `relatedObject` into `YardAreaPresenter` placeholder / initial data.
 */
export function relatedObjectToYardArea(
  related: Maybe<{ id: string; name?: string }>
): PresenterPlaceholderData<YardAreaDetails> | undefined {
  if (!related?.id) {
    return;
  }

  return toPresenterPlaceholder<YardAreaDetails>({ id: related.id, name: related.name });
}

/**
 * Maps check-task `relatedObject` into `YardSpotPresenter` placeholder / initial data.
 */
export function relatedObjectToYardSpot(
  related: Maybe<{ id: string; code?: string; type?: string; spotAreaId?: string }>
): PresenterPlaceholderData<YardSpotDetails> | undefined {
  if (!related?.id) {
    return;
  }

  return toPresenterPlaceholder<YardSpotDetails>({
    id: related.id,
    code: related.code ?? '',
    type: related.type ?? '',
    spotAreaId: related.spotAreaId ?? ''
  });
}

/**
 * Maps check-task `relatedObject` into `YardAssetPresenter` placeholder / initial data.
 */
export function relatedObjectToYardAsset(
  related: Maybe<{ id: string; code?: string; type?: string }>
): PresenterPlaceholderData<YardAssetDetails> | undefined {
  if (!related?.id) {
    return;
  }

  return toPresenterPlaceholder<YardAssetDetails>({
    id: related.id,
    code: related.code,
    type: related.type
  });
}
